import { db } from '@/lib/firebase';
import { 
  collection, 
  addDoc, 
  getDocs, 
  getDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  query, 
  where,
  orderBy,
  Timestamp 
} from 'firebase/firestore';

export interface Case {
  id?: string;
  beforeImage: string;
  afterImage: string;
  category: string;
}

// إنشاء حالة جديدة
export const createCase = async (caseData: Omit<Case, 'id'>): Promise<void> => {
  try {
    await addDoc(collection(db, 'cases'), {
      ...caseData,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now()
    });
  } catch (error) {
    console.error('Error creating case:', error);
    throw error;
  }
};

// الحصول على جميع الحالات
export const getAllCases = async (): Promise<Case[]> => {
  try {
    const q = query(collection(db, 'cases'), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => {
      const data = doc.data();
      // Safely handle createdAt field
      const createdAt = data.createdAt instanceof Timestamp ? data.createdAt.toDate() : new Date();
      return {
        id: doc.id,
        ...data,
        createdAt: createdAt
      };
    });
  } catch (error) {
    console.error('Error fetching cases:', error);
    throw error;
  }
};

// الحصول على حالة محددة
export const getCase = async (caseId: string) => {
  try {
    const docRef = doc(db, 'cases', caseId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      // Safely handle createdAt field
      const createdAt = data.createdAt instanceof Timestamp ? data.createdAt.toDate() : new Date();
      return { 
        id: docSnap.id, 
        ...data,
        createdAt: createdAt
      };
    }
    return null;
  } catch (error) {
    console.error('Error getting case:', error);
    throw error;
  }
};

// تحديث حالة
export const updateCase = async (id: string, caseData: Partial<Case>): Promise<void> => {
  try {
    const docRef = doc(db, 'cases', id);
    await updateDoc(docRef, {
      ...caseData,
      updatedAt: Timestamp.now()
    });
  } catch (error) {
    console.error('Error updating case:', error);
    throw error;
  }
};

// حذف حالة
export const deleteCase = async (id: string): Promise<void> => {
  try {
    const docRef = doc(db, 'cases', id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error('Error deleting case:', error);
    throw error;
  }
};

// الحصول على الحالات حسب الفئة
export const getCasesByCategory = async (category: string) => {
  try {
    const q = query(
      collection(db, 'cases'),
      where('category', '==', category),
      orderBy('createdAt', 'desc')
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => {
      const data = doc.data();
      // Safely handle createdAt field
      const createdAt = data.createdAt instanceof Timestamp ? data.createdAt.toDate() : new Date();
      return {
        id: doc.id,
        ...data,
        createdAt: createdAt
      };
    });
  } catch (error) {
    console.error('Error getting cases by category:', error);
    throw error;
  }
}; 